import React from 'react';
export const Hero = () => {
  return <section className="gradient-hero text-zinc-800 py-24 md:py-32 relative overflow-hidden" data-id="element-97">
      <div className="absolute inset-0 opacity-10" data-id="element-98">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://images.unsplash.com/photo-1639322537228-f710d846310a?q=80&w=2232&auto=format&fit=crop')] bg-cover bg-center opacity-20" data-id="element-99"></div>
      </div>
      <div className="container-custom relative z-10" data-id="element-100">
        <div className="max-w-3xl" data-id="element-101">
          <h1 className="font-serif text-4xl md:text-6xl mb-6 leading-tight text-zinc-900" data-id="element-102">
            Expert White-Glove{' '}
            <span className="accent-text" data-id="element-103">AI Product Development</span>
          </h1>
          <p className="text-zinc-600 text-lg md:text-xl mb-10 font-light" data-id="element-104">
            We turn clients' dreams of creating their own AI product into a
            reality. Rapidly.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-105">
            <a href="http://calendly.com/es-lee" target="_blank" rel="noopener noreferrer" className="bg-zinc-800 text-white px-8 py-3 rounded-sm hover:bg-zinc-700 transition-colors text-center" data-id="element-106">
              Book A Consultation
            </a>
            <a href="#services" className="border border-zinc-300 px-8 py-3 rounded-sm hover:bg-zinc-100 transition-colors text-center" data-id="element-107">
              Explore Services
            </a>
          </div>
        </div>
      </div>
      <div className="container-custom relative z-10 mt-24" data-id="element-108">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-109">
          <div className="border-t border-zinc-300 pt-6" data-id="element-110">
            <div className="font-serif text-4xl mb-2 text-zinc-900" data-id="element-111">10+</div>
            <div className="text-zinc-600" data-id="element-112">Years developing AI products</div>
          </div>
          <div className="border-t border-zinc-300 pt-6" data-id="element-113">
            <div className="font-serif text-4xl mb-2 text-zinc-900" data-id="element-114">1M+</div>
            <div className="text-zinc-600" data-id="element-115">People using our AI solutions</div>
          </div>
          <div className="border-t border-zinc-300 pt-6" data-id="element-116">
            <div className="font-serif text-4xl mb-2 text-zinc-900" data-id="element-117">10K+</div>
            <div className="text-zinc-600" data-id="element-118">Custom AI chatbots deployed</div>
          </div>
        </div>
      </div>
    </section>;
};